export default __webpack_public_path__ + "static/media/FATMUG1.3dd82610.jpg";